import { APPLICATION_PATHS } from '../../application-core/constants';
import SchemeChip from '../../vocabulary/core/SchemeChip';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import React from 'react';
import ExternalResourceLink from '../../core/ExternalResourceLink';
import withGS from '../../core/withGShoc';
import { globalStyles as styles } from '../../core/style/gstheme';

const loadOptions = {
  predicates: [
    "http://www.w3.org/2000/01/rdf-schema#label",
    "http://www.w3.org/2000/01/rdf-schema#isDefinedBy",
    "https://grafsync.graphifi.com/schema/gs/visibility",
    "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
    "http://www.w3.org/2002/07/owl#deprecated",
  ]
};

class ResourceDisplay extends React.Component {

  render() {

    const { data, classes, viewLang, defaultLang, graph, project, ontologies } = this.props;

    // If somebody else has deleted it we will now hide it
    if (data.pendingDeletion) return null;

    let label = "No label available";
    const displayLang = viewLang && data.label && data.label[viewLang] ?
      viewLang
      :
      data.label && data.label[defaultLang] ?
        defaultLang
        :
        "und";

    if (data.label && data.label[displayLang]) {
      label = Array.isArray(data.label[displayLang]) ?
        [...data.label[displayLang]].sort().join(" AND ")
        :
        data.label[displayLang];
    }

    let link = "";
    let resourceType = "";
    const resourceClass = Array.isArray(data.type) ? data.type : [data.type];
    if (resourceClass.includes("OwlClass")) {
      link += "&view=class&class=" + data.id;
      resourceType = "Class";
    }
    else if (resourceClass.includes("ObjectProperty")) {
      link += "&view=objectProperty&objectProperty=" + data.id;
      resourceType = "Object Property";
    }
    else if (resourceClass.includes("DatatypeProperty")) {
      link += "&view=datatypeProperty&datatypeProperty=" + data.id;
      resourceType = "Datatype Property";
    }
    else if (resourceClass.includes("AnnotationProperty")) {
      link += "&view=annotationProperty&annotationProperty=" + data.id;
      resourceType = "Annotation Property";
    }

    let ontology = data.visibility || data.isDefinedBy;

    return (
      <TableRow
        data-test={"resource-" + data.id}
        classes={{
          root: classes.stripedRow
        }}>
        <TableCell className={classes.tableCell} style={{ maxWidth: '300px', paddingTop: 12 }}>
          <Typography data-test={displayLang !== viewLang ? "no-lang-label" : "label"} className={classes.tableCellText} style={displayLang !== viewLang ? { color: '#FF6F00' } : {}}>
            {label}
          </Typography>
        </TableCell>
        <TableCell className={classes.tableCell} style={{ maxWidth: '300px', paddingTop: 12 }}>
          <Typography className={classes.tableCellText}>
            {resourceType}
          </Typography>
        </TableCell>
        <TableCell className={classes.tableCell} style={{ maxWidth: '300px', paddingTop: 12 }}>
          <Typography className={classes.tableCellText}>
            {data.id}
          </Typography>
        </TableCell>
        <TableCell className={classes.tableCell} style={{ maxWidth: '300px', paddingTop: 12 }}>
          {ontology &&
            <div key={ontology}>
              {ontologies.some(ontologyItem => ontologyItem.id === ontology) ?
                <SchemeChip
                  key={ontology}
                  id={ontology}
                  handleNotAvailable={true}
                  defaultLang={defaultLang}
                  isReadOnly={true}
                  graph={graph}
                  link={
                    APPLICATION_PATHS.ONTOLOGY_MANAGER + '/project/ontology#project='
                    + project + "&ontology=" + ontology + link
                  } />
                :
                <ExternalResourceLink
                  key={ontology}
                  id={ontology}
                  graph={graph}
                  source={data.id}
                  isReadOnly={true}
                  property="inScheme" />
              }
            </div>
          }
        </TableCell>
      </TableRow>
    );
  }
}

ResourceDisplay.propTypes = {
  classes: PropTypes.object,
  ontologies: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  graph: PropTypes.string.isRequired,
  project: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired,
  viewLang: PropTypes.string,
};

export default withStyles(styles)(withGS(ResourceDisplay, ["ALL"], null, loadOptions, true));